import Countdown from "react-countdown";
import { LI, UL } from "../../../AbstractElements";
import { Days, Hours, Minutes, Seconds } from "../../../Constant";
import { CountdownDataProp } from "../../../Type/Pages";

const CountdownData = () => {
  const Completionist = () => <span>{"You are good to go!"}</span>;
  const renderer = ({days,hours,minutes,seconds,completed,}: CountdownDataProp) => {
    if (completed) {
      return <Completionist />;
    } else {
      return (
        <div>
          <UL className="simple-list flex-row">
            <LI><span id="days" className="time digits">{days}</span><span className="title">{Days}</span></LI>
            <LI><span className="time digits" id="hours">{hours}</span><span className="title">{Hours}</span></LI>
            <LI><span className="time digits" id="minutes">{minutes}</span><span className="title">{Minutes}</span></LI>
            <LI><span className="time digits" id="seconds">{seconds}</span><span className="title">{Seconds}</span></LI>
          </UL>
        </div>
      );
    }
  };

  var d = new Date();
  var year = d.getFullYear();
  var month = d.getMonth();
  var day = d.getDate();
  var coundown = new Date(year, month, day + 60).getTime();

  return <Countdown date={coundown} renderer={renderer} />;
};

export default CountdownData;
